import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './ContactInfo.css';

const ContactInfo = () => {
  return (
    <div className="contact-info">
      <div className="info-card">
        <FaPhone className="info-icon" />
        <h3>Phone</h3>
        <p>+91 93808 67233</p>
      </div>
      <div className="info-card">
        <FaEnvelope className="info-icon" />
        <h3>Email</h3>
        <p>support@jobsopportunity.in</p>
      </div>
      <div className="info-card">
        <FaMapMarkerAlt className="info-icon" />
        <h3>Address</h3>
        <p>Hospet, Karnataka, India</p>
      </div>
    </div>
  );
};

export default ContactInfo; 